import * as _ from 'lodash';
import React from 'react';
import ReactDOM from 'react-dom';
import moment from 'moment';
import Helmet from 'react-helmet';
import ClipLoader from 'react-spinners/ClipLoader';
import { Box } from '@mui/material';

import { WorkersApi } from '../services/workers/WorkersApi';
import CompanyService from '../services/Companies';
import WorkersService from '../services/workers/WorkersService';
import WorkerInfoApi from '../services/workers/workerInfo/WorkerInfoApi';
import UsersApi from '../services/users/UsersApi';

import InfinityScrollLoad from '../components/InfinityScrollLoad';
import { DeleteWorkersConfirmDialog } from '../components/modals/DeleteWorkersConfirmDialog';
import { Confirmation, Information } from '../components/modals/common';
import { WorkersExportExcelDialog } from '../components/modals/WorkersExportExcelDialog';

import LocalStorageService from '../services/utilities/LocalStorageService';
import SessionStorageService from '../services/utilities/SessionStorageService';
import masterSlideLoader from '../utilities/masterSlideLoader';
import { messageUtility } from '../utilities/messageUtility';
import { extractErrorMessage, isApiFlagOff, isApiFlagOn } from '../utilities/commonUtil';
import {
  isLoginUserForeman,
  isPartnerRoleId,
  isPrimaryCompanyRoleId,
} from '../utilities/roleUtility';
import {
  isNullOrUndefinedOrEmptyStr,
  safariOnIosCheck,
} from '../utilities/stringUtil';
import {
  HEADER_CONSTANTS,
  WORKER_STATUS,
  DATE_TIME_FORMAT,
  WORKER_TAB,
  CCUS_SYNCED_STATUS,
  EXPORT_WORKERS_COMPANY_MAX_LENGTH,
  MAX_WORKER_COUNT_DEFAULT,
  USER_ROLES,
  ZENDESK_URL_GUIDE,
  RANK_CONSISTENCY_STATUS,
  CCUS_SYNCED_STATUSES,
  CCUS_JIGYOUSYA_DELETED_FLAG,
  DISPLAY_SETTINGS_CODE,
  FAQ_URL,
  API_FLAG,
} from '../utilities/constants';
import PrintUtility from '../utilities/printUtility';
import { hasRoanPermission } from '../utilities/companyUserPermissionUtil';
import { enableTouch } from '../utilities/tabletUtil';

import styles from '../styles/componentStyle/entrance/Workers-table.scss';
import CcusGuideImage1 from '../images/ccus_guide_1.svg';
import CcusGuideImage2 from '../images/ccus_guide_2.svg';
import { MasterPageHeader } from '../components/PageHeader';
import Tippy from '../components/ReactTippy';
import { QuestionIcon } from '../components/icons/QuestionIcon';
import Loader from '../components/Loader';
import { UserTypeSwitchForm } from '../components/UserTypeSwitchForm';
import {
  HEAD_OFFICE_OPTION,
  PartnerCompanyBranchDropdown,
} from '../components/PartnerCompanyBranchDropdown';
import { UpdatePartnerCompanyBranchWorkersDialog } from '../components/modals/UpdatePartnerCompanyBranchWorkersDialog';
import {
  checkNotMatchingRankNameCode,
  convertRankNameLevel,
  getRankConsistencyStatusName,
} from '../utilities/workerUtil';
import { isCcusJigyousyaNotConnectedError } from '../utilities/apiErrorMessage';

/**
 * @description 作業員一覧
 */
export default class Workers extends React.Component {
  constructor(props) {
    super(props);
    // IEのみファイルアップロードするとconsoleにTypeMismatchErrorエラーが表示される問題の対策
    window.onunhandledrejection = function(event) {
      event.preventDefault();
    };
    const selectedPartnerCompanyId = SessionStorageService.getSessionSelectedPartnerCompanyId();
    if (isNullOrUndefinedOrEmptyStr(selectedPartnerCompanyId)) {
      throw new Error('Workers.jsx constructor selectedPartnerCompanyId');
    }

    // 元請ユーザーの場合、表示権限エラー画面に遷移
    this.roleId = LocalStorageService.getRoleId(); // ロールID
    if (isPrimaryCompanyRoleId(this.roleId)) {
      return window.location.replace('/error-permission');
    }

    this.defaultParams = {
      offset: 0,
      limit: 30,
      order: 'asc',
      sortkey: null,
      ccus_engineer_id: null,
      partner_company_branch_id: null,
      isQuiet: true,
      rank_consistency_statuses: [],
      ccus_synced_statuses: [],
      ccus_jigyousya_deleted_flag: null,
    };

    this.state = {
      roleId: LocalStorageService.getRoleId(),
      total: 0,
      params: { ...this.defaultParams },
      searchParams: { ...this.defaultParams },
      search_form_open: true, // search_form の開閉
      search_form_inputs_refs: {}, //検索項目
      selects: [], //選択一覧
      isSelectAll: false,
      Workers: [],
      //ダイアログの表示非表示
      dialog: {
        delete: false,
        showStatusDialog: false, //ステータス変更ダイアログ表示フラグ
        showMessageDialog: false,
        ccusConnectionConfirmDialog: false,
        workerRegistrationApplicationDialog: false,
        workerExportExcelDialog: false,
        partnerCompanyBranchDialog: false,
        infoDialog: false,
        ccusGuideDialog: false,
        showDialogCcusJigyousya: false,
      },
      isInitLoading: true, //初期表示時のロード中フラグ
      isListLoading: false, //作業員一覧ロード中フラグ
      isAgencyRegister: false, // 代行登録かどうか？ ( true: 代行登録 false: 自社作業員 )
      selectedPartnerCompanyId,
      selectedPartnerCompanyName: '',
      messageContent: null,
      changeStatus: {
        selectWorkerStatus: 0,
        WorkerId: '',
      },
      ccusConnectionConfirmDialog: {
        // CCUS連携ダイアログ用プロパティ
        approvedFlag: false, // 同意するにチェックされているか
      },
      exportFiles: [],
      maxWorkerCount: MAX_WORKER_COUNT_DEFAULT,
      partnerCompanyBranchId: null,
      isRoanPermission: false,
      infoDialogTitle: null,
      infoDialogMessage: null,
      changePartnerCompanyBranchSelectedWorkers: [],
      isBuildeeManager: false,
      infoDialogCloseCallback: null,
      isPartner: false,
      allLoaded: false, // 作業員データが全てロードされたか
      isCheckedNotShowAgainCcusGuide: false,
      isCcusJigyousyaConnected: false,
    };
    this.requestConnectionCcusFlag = false; // 多重取得防止Flag
    this.userId = LocalStorageService.getUserId(); // ユーザーID
    this.searchButtonRef = React.createRef(); // 検索ボタン要素

    this.requestData = this.requestData.bind(this);

    this.events = {
      dialog: {
        delete: this.handleDeleteDialogShow.bind(this),
        showChangeStatus: this.showDetailDialog.bind(this),
        closeStatusDialog: this.closeStatusDialog.bind(this),
        bulkChangeCompanyBranchDialog: this.bulkChangeCompanyBranchDialog,
      },
      search: {
        gets: this.handleSearchWorkers.bind(this), //検索
        execution: this.searchExecution.bind(this), // 検索実行
        clear: this.handleSearchClear.bind(this), //検索リセット
        searchCCUS: this.handleSearchCCUS,
        searchDeleted: this.handleSearchDeleted,
      },
      table: {
        selectedRow: this.handleSelectedRow.bind(this), // 単一選択
        selectedAll: this.handleSelectedAll.bind(this), // 全選択
      },
      onSort: this.onSort.bind(this),
      showWorkerDetail: this.handleShowWorkerDetail.bind(this),
      changeMasterSlideLoader: this.changeMasterSlideLoader.bind(this), // 画面遷移
      openCcusConnectionConfirmDialog: this.openCcusConnectionConfirmDialog.bind(
        this
      ), // CCUS連携確認ダイアログ
      requestConnectionCcus: this.requestConnectionCcus.bind(this), // CCUS連携
      settingSortParams: this.settingSortParams.bind(this), // ソートパラメーター設定
      goBack: this.goBack.bind(this), // 代行登録会社一覧へ戻る
      checkStatus: this.checkStatus.bind(this),
      changeStatus: this.changeStatus.bind(this),
    };
    this.exportExcelParams = {};
    this.exportExcelFlag = false;
    this.partnerCompanyJoiningFlag = SessionStorageService.getPartnerCompanyJoiningFlag();
    this.isCallingApiFlag = false;
    this.isPartnerCompanyBranchUpdatingFlag = false;
    this.isPartnerRoleId = isPartnerRoleId(this.state.roleId);
  }

  /**
   * 「CCUS一括連携」ボタン連打防止フラグに値をセット
   * */
  setRequestConnectionCcusFlag = value => {
    this.requestConnectionCcusFlag = value;
  };

  checkFromAgencyRegister = async () => {
    const selectedPartnerCompanyId = SessionStorageService.getSessionSelectedPartnerCompanyId();
    const partnerCompanyIdOfPrimeCompany = SessionStorageService.getSessionPartnerCompanyIdOfPrimeCompany();

    const isAgencyRegister =
      selectedPartnerCompanyId !== partnerCompanyIdOfPrimeCompany;
    if (!isAgencyRegister) {
      SessionStorageService.removeItem(
        'selectedPartnerCompanyAgencyRegistrationPermissionStatus'
      );
    }
    this.setState({
      isAgencyRegister,
    });
    if (this.isPartnerRoleId) {
      const isFirstTimeAccess = isAgencyRegister
        ? LocalStorageService.getIsFirstTimeAccessWorkerAgency()
        : LocalStorageService.getIsFirstTimeAccessWorker();
      if (!isFirstTimeAccess) {
        return;
      }
      isAgencyRegister
        ? LocalStorageService.setIsFirstTimeAccessWorkerAgency(false)
        : LocalStorageService.setIsFirstTimeAccessWorker(false);
      await this.checkShowDialogCcusWarning(isAgencyRegister);
    }
  };

  async requestData() {
    const selectedPartnerCompanyId = SessionStorageService.getSessionSelectedPartnerCompanyId();

    // 作業中の会社情報を取得
    const response = await CompanyService.show(selectedPartnerCompanyId);
    const state = _.cloneDeep(this.state);
    if (response.result) {
      state.selectedPartnerCompanyName = response.data.entities.company.name;
      state.isCcusJigyousyaConnected = !!_.get(
          response.data.entities.company,
          'ccus_jigyousya_id'
      );
    }

    // 検索用のプロパティの初期化と一覧取得用のデータを初期化する
    state.selectedPartnerCompanyId = selectedPartnerCompanyId;
    state.partnerCompanyBranchId = null;
    state.params = { ...this.defaultParams };
    state.searchParams = { ...this.defaultParams };
    state.total = 0;
    state.selects.length = 0;
    state.Workers.length = 0;

    // 検索条件をクリアする
    state.search_form_open = true;
    _.map(state.search_form_inputs_refs, item => {
      item.value = '';
      item.checked = false;
    });
    state.isSelectAll = false;

    this.setState(state, () => {
      this.loadWorkers();
    });
  }

  checkShowDialogCcusWarning = isAgencyRegister => {
    return WorkersApi.getDialogDisplaySettings({
      dialog_code: isAgencyRegister
        ? DISPLAY_SETTINGS_CODE.AGENCY_COMPANY
        : DISPLAY_SETTINGS_CODE.COMPANY,
    }).then(response => {
      if (response.result) {
        if (
          isApiFlagOn(
            _.get(
              response,
              'data.entities.dialog_display_settings[0].show_dialog_flag',
              API_FLAG.On
            )
          )
        ) {
          this.setState(prevState => ({
            dialog: {
              ...prevState.dialog,
              ccusGuideDialog: true,
            },
            isCheckedNotShowAgainCcusGuide: false,
          }));
        }
      }
    });
  };

  /**
   * React Component LifeCycle
   * マウントが行われた直後
   * */
  async componentDidMount() {
    await this.checkFromAgencyRegister();

    const isRoanPermission = await this.checkRoanPermission();
    const isPartner = isPartnerRoleId(this.state.roleId);
    await this.checkBuildeeManager();
    this.setState(
      {
        isRoanPermission,
        isPartner,
      },
      () => {
        this.requestData();
      }
    );
  }

  checkRoanPermission = async () => {
    // 代行登録状態では常に労務安全機能を開放する
    if (this.state.isAgencyRegister) {
      return true;
    }
    try {
      const result = await hasRoanPermission(
        SessionStorageService.getSessionSelectedPartnerCompanyId()
      );
      return result;
    } catch (e) {
      return false;
    }
  };

  checkBuildeeManager = async () => {
    this.setState({
      isBuildeeManager: false,
    });
    if (isLoginUserForeman()) {
      return;
    }

    const selectedPartnerCompanyId = SessionStorageService.getSessionSelectedPartnerCompanyId();
    const response = await UsersApi.fetchCompanyUserPermissions(
      selectedPartnerCompanyId,
      { buildee_manager_flg: 1 }
    );
    if (response.result && response.data.total > 0) {
      const companyUserPermissions = _.get(
        response,
        'data.entities.company_user_permissions'
      );
      const isBuildeeManager = _.some(companyUserPermissions, [
        'user_id',
        this.userId,
      ]);
      this.setState({
        isBuildeeManager,
      });
    }
  };

  /**
   * React Component LifeCycle
   * 更新が実行された直後
   * */
  async componentDidUpdate(prevProps, prevState) {
    const selectedPartnerCompanyId = SessionStorageService.getSessionSelectedPartnerCompanyId();
    if (prevState.selectedPartnerCompanyId !== selectedPartnerCompanyId) {
      if (this.isCallingApiFlag) {
        return;
      }
      this.isCallingApiFlag = true;
      await this.checkFromAgencyRegister();
      const isRoanPermission = await this.checkRoanPermission();
      await this.checkBuildeeManager();
      this.setState(
        {
          isRoanPermission,
        },
        async () => {
          await this.requestData();
          this.isCallingApiFlag = false;
        }
      );
    }
  }

  goBack = () => {
    masterSlideLoader.show('AgencyCompanies', {
      state: {},
    });
  };

  /**
   * 取得したデータ全選択
   * @params selected {boolean} 選択したかどうか判定
   */
  handleSelectedAll = selected => {
    //選択を配列に入れる
    const selectAll = items => {
      if (items.length === 0) {
        return [];
      }
      return _.map(items, item => {
        return item.id;
      });
    };

    const selects = selected ? selectAll(_.cloneDeep(this.state.Workers)) : [];
    this.setState({ selects, isSelectAll: selected });
  };

  /**
   * 予定単一選択
   * @params companyBranchId {int}
   * @params selected {boolean} // 選択済み判定
   */
  handleSelectedRow = (e, id) => {
    let _selects = _.cloneDeep(this.state.selects);
    if (e.target.checked) {
      _selects.push(id);
    } else {
      _selects = _selects.filter(n => n !== id);
    }
    this.setState({ selects: _selects });
  };

  /**
   * 作業員を検索
   */
  handleSearchWorkers = (value, keyname) => {
    const params = _.cloneDeep(this.state.params);
    params[keyname] = value;
    this.setState({ params });
  };
  // BLDE_V2-42611 連携解除ステータスの作業員を検索
  handleSearchDeleted = (checked, keyname, keyname2, value, value2) => {
    const params = _.cloneDeep(this.state.params);
    if (checked) {
      params[keyname] = value;
      params[keyname2].push(value2);
    } else {
      params[keyname] = null;
      _.pull(params[keyname2], value2);
    }
    this.setState({ params });
  };
  handleSearchCCUS = (checked, keyname, value) => {
    const params = _.cloneDeep(this.state.params);
    if (checked) {
      params[keyname].push(value);
    } else {
      _.pull(params[keyname], value);
    }
    this.setState({ params });
  };

  /**
   * @description 検索実行
   */
  searchExecution() {
    this.searchButtonRef.current.disabled = true;
    this.setState(
      prevState => ({
        ...prevState,
        Workers: [],
        params: {
          ...prevState.params,
          partner_company_branch_id:
            prevState.params.partner_company_branch_id || null,
          offset: 0,
        },
        searchParams: prevState.params,
        selects: [],
        isSelectAll: false,
      }),
      this.loadWorkers
    );
  }

  /**
   * 検索リセット
   */
  handleSearchClear = () => {
    let state = { ...this.state };
    state.Workers = [];
    state.selects = [];
    state.dialog.delete = false;
    state.partnerCompanyBranchId = null;
    state.params = { ...this.defaultParams };
    state.searchParams = { ...this.defaultParams };
    _.map(state.search_form_inputs_refs, item => {
      item.value = '';
      item.checked = false;
    });
    state.isSelectAll = false;
    this.setState(state, this.loadWorkers);
  };

  /**
   * 削除ダイアログ表示
   */
  handleDeleteDialogShow(b) {
    if (this.state.isRoanPermission) {
      if (this.state.selects.length === 0) {
        this.handleNotSelectedWorker();
        return;
      }
      let dialog = _.cloneDeep(this.state.dialog);
      dialog.delete = b;
      this.setState({ dialog });
    }
  }

  /**
   * 削除確認ダイアログ
   */
  handleNotSelectedWorker = () => {
    this.showInfoDialog(
      '作業員を選択してください',
      '削除対象の作業員を選択してください。'
    );
  };

  /**
   * ステータスダイアログを表示する
   * @param {object}worker:作業員
   */
  showDetailDialog = worker => {
    const state = { ...this.state };
    state.dialog.showStatusDialog = true;
    state.changeStatus.WorkerId = worker.id;
    state.changeStatus.selectWorkerStatus = worker.blocked_on
      ? WORKER_STATUS.RETIREMENT.ID
      : WORKER_STATUS.ENROLLMENT.ID;
    this.setState(state);
  };

  /**
   * ダイアログを閉じる
   */
  closeStatusDialog = () => {
    const state = { ...this.state };
    state.dialog.showStatusDialog = false;
    this.setState(state);
  };

  /**
   * エラーダイアログ表示
   * @param message
   */
  showErrorDialog(message) {
    this.handleVisibleDialog();
    this.setState({ messageContent: message });
  }

  /**
   * ダイアログ開閉設定
   */
  handleVisibleDialog(key = 'showMessageDialog') {
    this.setState(
      {
        dialog: { [key]: !this.state.dialog[key] },
      },
      () => {
        // BLDE_V2-29049 ダイアログの表示後、テーブルデータを再読み込みする
        this.searchExecution();
      }
    );
    this.setRequestConnectionCcusFlag(false);
  }

  /**
   * Open dialog register worker
   **/
  openRegisterWorkerConfirmDialog = () => {
    if (this.state.isRoanPermission) {
      const stateValue = _.cloneDeep(this.state);
      stateValue.dialog.workerRegistrationApplicationDialog = true;
      this.setState(stateValue);
    }
  };

  /**
   * CCUS連携確認ダイアログを開く
   **/
  openCcusConnectionConfirmDialog() {
    const stateValue = _.cloneDeep(this.state);
    stateValue.dialog.ccusConnectionConfirmDialog = true;
    this.setState(stateValue);
  }

  /**
   * CCUS連携ダイアログを閉じる
   **/
  closeCcusConnectionConfirmDialog = () => {
    const stateValue = _.cloneDeep(this.state);
    stateValue.dialog.ccusConnectionConfirmDialog = false;
    stateValue.ccusConnectionConfirmDialog.approvedFlag = false;
    this.setState(stateValue);
  };

  /**
   * close dialog register worker
   **/
  closeWorkerRegisterApplicationDialog = () => {
    const stateValue = _.cloneDeep(this.state);
    stateValue.dialog.workerRegistrationApplicationDialog = false;
    this.setState(stateValue);
  };

  /**
   * CCUS連携後にダイアログを表示する
   * @param message: メッセージ
   **/
  showCcusConnectionMessageDialog = message => {
    const stateValue = _.cloneDeep(this.state);
    stateValue.dialog.ccusConnectionConfirmDialog = false;
    stateValue.ccusConnectionConfirmDialog.approvedFlag = false;
    if (
      !this.state.isCcusJigyousyaConnected ||
      isCcusJigyousyaNotConnectedError(message)
    ) {
      stateValue.dialog.showDialogCcusJigyousya = true;
    } else {
      stateValue.dialog.showMessageDialog = true;
      stateValue.messageContent = message;
    }
    this.setState(stateValue);
  };

  showWorkerExportExcelDialog = exportFiles => {
    const stateValue = _.cloneDeep(this.state);
    stateValue.dialog.workerExportExcelDialog = true;
    stateValue.exportFiles = exportFiles;
    this.setState(stateValue);
  };

  closeWorkerExportExcelDialog = () => {
    const stateValue = _.cloneDeep(this.state);
    stateValue.dialog.workerExportExcelDialog = false;
    this.setState(stateValue);
  };

  handleVisibleCcusGuideDialog = isShow => {
    const params = {
      dialog_code: this.state.isAgencyRegister
        ? DISPLAY_SETTINGS_CODE.AGENCY_COMPANY
        : DISPLAY_SETTINGS_CODE.COMPANY,
    };
    if (isShow) {
      WorkersApi.getDialogDisplaySettings(params).then(response => {
        if (response.result) {
          const isCheckedNotShowAgainCcusGuide = isApiFlagOff(
            _.get(
              response,
              'data.entities.dialog_display_settings[0].show_dialog_flag',
              API_FLAG.On
            )
          );
          this.setState(prevState => ({
            dialog: {
              ...prevState.dialog,
              ccusGuideDialog: true,
            },
            isCheckedNotShowAgainCcusGuide,
          }));
        }
      });
    } else {
      this.setState(prevState => ({
        dialog: { ...prevState.dialog, ccusGuideDialog: false },
      }));
      // call api to update dialog display settings when close CCUS guide dialog
      params.show_dialog_flag = this.state.isCheckedNotShowAgainCcusGuide
        ? API_FLAG.Off
        : API_FLAG.On;
      WorkersApi.updateDialogDisplaySettings(params);
    }
  };

  handleChangeCcusGuideCheckbox = isChecked => {
    this.setState({ isCheckedNotShowAgainCcusGuide: isChecked });
  };

  /**
   * CCUS連携を同意するチェックを変更
   **/
  changeCcusApprovedFlag = () => {
    const stateValue = _.cloneDeep(this.state);
    stateValue.ccusConnectionConfirmDialog.approvedFlag = !stateValue
      .ccusConnectionConfirmDialog.approvedFlag;
    this.setState(stateValue);
  };

  /**
   * CCUS連携
   **/
  requestConnectionCcus() {
    // 連打防止対応
    if (this.requestConnectionCcusFlag) {
      return;
    }
    this.setRequestConnectionCcusFlag(true);

    const stateValue = _.cloneDeep(this.state);
    const params = WorkersService.requestConnectionCcusParam(
      stateValue.selectedPartnerCompanyId
    );
    WorkersApi.requestConnectionCcus(params)
      .then(response => {
        if (response.result) {
          this.showCcusConnectionMessageDialog(
            messageUtility.getMessage('I-000-086')
          );
        } else {
          this.showCcusConnectionMessageDialog(extractErrorMessage(response));
        }
      })
      .catch(error => {
        this.showCcusConnectionMessageDialog(extractErrorMessage(error));
      });
  }

  handleShowWorkerDetail = id => {
    this.changeMasterSlideLoader('WorkerConfirm', {
      state: {
        id: `${WORKER_TAB.WORKER_INFO.TAB_NAME},${id}`,
      },
    });
  };

  /**
   * ソート検索用パラメーターを設定
   * @param {*} params
   * @returns 検索用パラメーター
   */
  settingSortParams(params) {
    switch (params.sortkey) {
      case 'fullname_kana':
        params.sort_fullname_kana = params.order;
        delete params.order;
        break;
      case 'birthday':
        params.order = `${params.sortkey}_${params.order}`;
        break;
      case 'ccus_engineer_id':
        params.order = `reservation_ccus_engineer_id_${params.order}`;
        break;
      case 'partner_company_branch_name':
        params.sort_partner_company_branch_name = params.order;
        delete params.order;
        break;
      default:
        delete params.order;
        break;
    }
    delete params.sortkey;
    return params;
  }
  // ページをスクロールしたときに発生した無限ループを防止
  handleScroll = notify => {
    if (!this.state.isListLoading && !this.state.allLoaded) {
      this.loadWorkers(notify);
    }
  };

  /**
   * @description table itemのデータを追加ロードする
   */
  loadWorkers(notify) {
    const state = { ...this.state };

    // 全件数取得していたら、続きは取得しない
    if (
      (state.Workers.length > 0 && state.Workers.length === state.total) ||
      state.isListLoading
    ) {
      return;
    }

    const searchParams = this.settingSortParams(
      _.cloneDeep(state.searchParams)
    );

    this.setState(
      {
        isListLoading: true,
      },
      () => {
        WorkersApi.list(state.selectedPartnerCompanyId, searchParams)
          .then(response => {
            if (response.result === true) {
              const stateValue = _.cloneDeep(this.state);
              _.map(response.data.entities.worker, item => {
                if (isNullOrUndefinedOrEmptyStr(item.birthday) === false) {
                  item.birthday = moment(
                    new Date(item.birthday).toISOString()
                  ).format(DATE_TIME_FORMAT.slashDateFormat);
                }
                item.rank_name_code &&
                  (item.rank_name_code = Number(item.rank_name_code));
                stateValue.Workers.push(item);
              });

              if (stateValue.Workers.length > 0) {
                stateValue.searchParams.offset = stateValue.Workers.length;
              }

              stateValue.total = response.data.total;
              stateValue.allLoaded =
                stateValue.Workers.length === stateValue.total;
              this.setState(stateValue);
            }
          })
          .finally(() => {
            this.setState(
              {
                isInitLoading: false,
                isListLoading: false,
              },
              () => {
                this.searchButtonRef.current.disabled = false;
              }
            );
          });

        if (notify) {
          notify();
        }
        this.exportExcelParams = _.cloneDeep(searchParams);
      }
    );
  }

  /**
   * 作業員削除ダイアログ
   * @param dialog
   */
  getDeleteDialog(dialog) {
    if (!dialog || this.state.selects.length === 0) {
      return null;
    }
    const workers = _.map(this.state.selects, select => {
      return _.filter(this.state.Workers, worker => {
        if (worker.id === select) {
          return worker;
        }
      })[0];
    });
    return (
      <BackgroundLayer modalRoot='root' modalState={this.state.dialog.delete}>
        <DeleteWorkersConfirmDialog
          show={this.state.dialog.delete}
          workers={workers}
          companyId={this.state.selectedPartnerCompanyId}
          back={() => {
            this.events.dialog.delete(false);
          }}
          submit={() => {
            this.events.dialog.delete(false);
            // 削除に成功した後は選択情報をクリアする。
            this.setState({ selects: [] });
            this.handleSearchClear();
          }}
        />
      </BackgroundLayer>
    );
  }

  /**
   * 検索項目のRefを保持
   * @param {string} name
   * @param {*} ref
   */
  setSearchInputRefs(name, ref) {
    let _search_form_inputs_refs = _.cloneDeep(
      this.state.search_form_inputs_refs
    );
    if (!_.has(_search_form_inputs_refs, name)) {
      _search_form_inputs_refs[name] = ref;
      this.setState({ search_form_inputs_refs: _search_form_inputs_refs });
    }
  }

  /**
   * ソート変更
   */
  onSort(key) {
    this.setState(
      prevState => ({
        ...prevState,
        Workers: [],
        searchParams: {
          ...prevState.searchParams,
          order: prevState.searchParams.order === 'asc' ? 'desc' : 'asc',
          offset: 0,
          sortkey: key,
        },
        selects: [],
        isSelectAll: false,
        dialog: {
          ...prevState.dialog,
          delete: false,
        },
      }),
      this.loadWorkers
    );
  }

  /**
   * 画面遷移
   */
  changeMasterSlideLoader = (slidename, data) => {
    masterSlideLoader.show(slidename, data);
  };

  /**
   * @description ステータスラジオボタン変更イベント
   * @param selectedStatus
   */
  checkStatus(selectedStatus) {
    const state = { ...this.state };
    state.changeStatus.selectWorkerStatus = selectedStatus;
    this.setState(state);
  }

  /**
   * 作業員ステータスを変更する。
   */
  changeStatus() {
    const state = { ...this.state };
    if (state.changeStatus.selectWorkerStatus === WORKER_STATUS.RETIREMENT.ID) {
      WorkersApi.inactive({
        worker_ids: [state.changeStatus.WorkerId],
      })
        .then(res => {
          if (res.result) {
            let success = res.data.success;
            success.forEach(WorkerId => {
              _.map(state.Workers, worker => {
                if (WorkerId === worker.id) {
                  worker.blocked_on = 1;
                }
              });
            });
            this.setState(state);
            this.closeStatusDialog();
          } else {
            this.showErrorDialog(extractErrorMessage(res));
          }
        })
        .catch(error => {
          this.showErrorDialog(extractErrorMessage(error));
        });
    } else if (
      state.changeStatus.selectWorkerStatus === WORKER_STATUS.ENROLLMENT.ID
    ) {
      WorkersApi.active({
        worker_ids: [state.changeStatus.WorkerId],
      })
        .then(res => {
          if (res.result) {
            let success = res.data.success;
            success.forEach(WorkerId => {
              _.map(state.Workers, worker => {
                if (WorkerId === worker.id) {
                  worker.blocked_on = 0;
                }
              });
            });
            this.setState(state);
            this.closeStatusDialog();
          } else {
            this.showErrorDialog(extractErrorMessage(res));
          }
        })
        .catch(error => {
          this.showErrorDialog(extractErrorMessage(error));
        });
    }
  }

  exportExcel = async () => {
    if (this.exportExcelFlag || !this.state.isRoanPermission) {
      return;
    }
    this.exportExcelFlag = true;
    const { selectedPartnerCompanyId } = this.state;
    const { getUrl, params } = WorkersService.getExportExcelRequestOptions(
      selectedPartnerCompanyId,
      this.exportExcelParams
    );
    const url = await getUrl();

    WorkersApi.getExportExcelFileInfo(url, {
      ...params,
      first_request: true,
    }).then(response => {
      const { total, limit } = response.data;
      this.setState({
        maxWorkerCount: limit || MAX_WORKER_COUNT_DEFAULT,
      });
      const totalFilesCount = Math.ceil(total / limit);

      if (totalFilesCount > 1) {
        const files = [];

        for (let i = 0; i < totalFilesCount; i++) {
          const fileParams = {
            ...params,
            limit,
            offset: i * limit,
          };

          let src = url;
          _.each(fileParams, (value, key) => {
            if (_.isArray(value)) {
              _.each(value, item => {
                src = src.concat(`&${key}[]=${encodeURIComponent(item)}`);
              });
            } else {
              src = src.concat(`&${key}=${encodeURIComponent(value)}`);
            }
          });
          files.push({ id: i + 1, src });
        }

        this.showWorkerExportExcelDialog(files);
        this.exportExcelFlag = false;
      } else {
        Loader.start();
        const fileParams = {
          ...params,
          offset: 0,
          limit,
        };
        let src = url;
        _.each(fileParams, (value, key) => {
          if (_.isArray(value)) {
            _.each(value, item => {
              src = src.concat(`&${key}[]=${encodeURIComponent(item)}`);
            });
          } else {
            src = src.concat(`&${key}=${encodeURIComponent(value)}`);
          }
        });

        WorkersApi.getExportExcelFile(src)
          .then(response => {
            const fileName = `作業員マスタ_${this.state.selectedPartnerCompanyName.slice(
              0,
              EXPORT_WORKERS_COMPANY_MAX_LENGTH
            )}.xlsx`;
            PrintUtility.printBlob(response, fileName);
            this.exportExcelFlag = false;
          })
          .finally(() => {
            Loader.done();
            this.exportExcelFlag = false;
          });
      }
    }).catch(() => {
      this.exportExcelFlag = false;
    });
  };

  handleSelectPartnerCompanyBranch = partnerCompanyBranchId => {
    const { params } = this.state;
    this.setState({
      partnerCompanyBranchId,
      params: {
        ...params,
        partner_company_branch_id: partnerCompanyBranchId,
      },
    });
  };

  toggleDialog = (dialogName, value, callback) => {
    let dialog = _.cloneDeep(this.state.dialog);
    dialog[dialogName] = value;
    this.setState({ dialog }, callback);
  };

  showInfoDialog = (title, message, closeCallback) => {
    this.setState(
      {
        infoDialogTitle: title,
        infoDialogMessage: message,
        infoDialogCloseCallback: closeCallback,
      },
      () => {
        this.toggleDialog('infoDialog', true);
      }
    );
  };

  bulkChangeCompanyBranchDialog = () => {
    if (this.state.selects.length === 0) {
      this.showInfoDialog(
        '作業員が選択されていません',
        '変更対象となる作業員が選択されていません。支店を変更する作業員を選択してください。'
      );
      return;
    }

    this.toggleDialog('partnerCompanyBranchDialog', true);

    const selectedWorkers = _.map(this.state.selects, workerId => {
      return _.find(this.state.Workers, ['id', workerId]);
    });
    this.setState({
      changePartnerCompanyBranchSelectedWorkers: selectedWorkers,
    });
  };

  handleBulkUpdatePartnerCompanyBranch = values => {
    if (this.isPartnerCompanyBranchUpdatingFlag) {
      return;
    }
    this.isPartnerCompanyBranchUpdatingFlag = true;
    const partnerCompanyBranchId =
      values.partner_company_branch_id !== HEAD_OFFICE_OPTION.id
        ? values.partner_company_branch_id
        : null;
    let updateDialog = true;
    WorkerInfoApi.bulkUpdatePartnerCompanyBranch(
      this.state.selectedPartnerCompanyId,
      {
        partner_company_branch_id: partnerCompanyBranchId,
        worker_ids: this.state.selects,
      },
      false
    )
      .then(() => {
        this.showInfoDialog(
          '支店の一括変更完了',
          '支店の一括変更が完了しました。',
          () => {
            this.handleSearchClear();
          }
        );
      })
      .catch(e => {
        if (e.status === 404 || e.status === 403) {
          updateDialog = false;
          return window.location.replace('/error-permission');
        }
        this.showInfoDialog(
          '更新に失敗しました',
          _.get(e, 'data.message') ||
            'エラーが発生しました。再度操作を行ってください。'
        );
      })
      .finally(() => {
        this.isPartnerCompanyBranchUpdatingFlag = false;
        if (updateDialog) {
          this.toggleDialog('partnerCompanyBranchDialog', false);
        }
      });
  };

  onCloseInfoDialog = () => {
    this.toggleDialog('infoDialog', false, this.state.infoDialogCloseCallback);
  };

  render() {
    let masterSlideViewTableHeight = 'calc(100vh - 84px)';
    // ios-safariだとツールバー分の高さがある為、考慮する
    // 後々ブラッシュアップが必要
    if (safariOnIosCheck() === true) {
      masterSlideViewTableHeight = 'calc(100vh - 115px)';
    }

    const title = `${this.state.selectedPartnerCompanyName} 作業員一覧`;
    const partnerCompanyPermissionStatus = SessionStorageService.getSelectedPartnerCompanyAgencyRegistrationPermissionStatus();
    const havePermissionWorkerRegistrationApp =
      !this.state.isAgencyRegister || partnerCompanyPermissionStatus;

    return (
      <div className='master-slide-view show WorkersTable'>
        <Helmet>
          <title>
            {HEADER_CONSTANTS.gatekeeper} - {title}
          </title>
        </Helmet>
        <div className='master-slide-view__view'>
          <div className={styles['workers-table']}>
            <MasterPageHeader
              title={title}
              loaded={!this.state.isInitLoading}
              loaderComponent={<ClipLoader size={20} color={'#EDB715'} />}
              onClose={() => masterSlideLoader.close()}
            />
            <div
              id='infinityscroll-target'
              className='master-slide-view__table'
              style={{ height: masterSlideViewTableHeight }}
            >
              {this.state.isPartner ? (
                <HeaderMenu
                  companyId={this.state.selectedPartnerCompanyId}
                  events={this.events}
                  isInitLoading={this.state.isInitLoading}
                  isAgencyRegister={this.state.isAgencyRegister}
                  openRegisterWorkerConfirmDialog={
                    this.openRegisterWorkerConfirmDialog
                  }
                  exportExcel={this.exportExcel}
                  isRoanPermission={this.state.isRoanPermission}
                  isActiveUpdatePartnerCompanyBranchButton={
                    !!(
                      this.state.isBuildeeManager &&
                      this.partnerCompanyJoiningFlag
                    )
                  }
                />
              ) : (
                <HelpTextDeleteWorker className='help-text-foreman' />
              )}
              <WorkerRegistrationAttention
                roleId={this.roleId}
                isAgencyRegister={this.state.isAgencyRegister}
                showCcusGuideDialog={() =>
                  this.handleVisibleCcusGuideDialog(true)
                }
              />
              <SearchForm
                onOpen={() =>
                  this.setState({
                    search_form_open: !this.state.search_form_open,
                  })
                }
                isOpen={this.state.search_form_open}
                total={this.state.total}
                clearParams={() => {
                  this.events.search.clear();
                }}
                events={this.events.search}
                setRef={this.setSearchInputRefs.bind(this)}
                searchButtonRef={this.searchButtonRef}
                partnerCompanyJoiningFlag={this.partnerCompanyJoiningFlag}
                selectedCompanyId={this.state.selectedPartnerCompanyId}
                selectedPartnerCompanyBranchId={
                  this.state.partnerCompanyBranchId
                }
                onSelect={this.handleSelectPartnerCompanyBranch}
                hidePartnerCompanyBranch={this.isCallingApiFlag}
                isPartner={this.state.isPartner}
                isRoanPermission={this.state.isRoanPermission}
              />

              <div className='master-slide-view__body'>
                <div className='constructionlist__list'>
                  <table className='table'>
                    <TableHeader
                      events={this.events}
                      params={this.state.searchParams}
                      isPartner={this.state.isPartner}
                      isSelectAll={this.state.isSelectAll}
                    />
                    <tbody id='body' className='table__body'>
                      {_.map(this.state.Workers, (worker, index) => (
                        <TableItem
                          key={index}
                          data={worker}
                          params={this.state.params}
                          selects={this.state.selects}
                          events={this.events}
                          isPartner={this.state.isPartner}
                          isRoanPermission={this.state.isRoanPermission}
                        />
                      ))}
                    </tbody>
                  </table>
                  <InfinityScrollLoad
                    total={this.state.total}
                    targetId={'infinityscroll-target'}
                    callback={notify => this.handleScroll(notify)}
                    isLoading={this.state.isListLoading}
                    ignoreIndicator={true}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
        {this.getDeleteDialog(this.state.dialog.delete)}
        <Confirmation
          visible={this.state.dialog.showStatusDialog === true}
          title={'ステータスの変更'}
          confirmButtonText={'変更'}
          cancelButtonText={'戻る'}
          message={
            <StatusDialog
              events={this.events}
              change_state={this.state.changeStatus}
            />
          }
          rootClassName={styles.statusDialog}
          onCancel={() => this.events.dialog.closeStatusDialog()}
          onConfirm={() => this.events.changeStatus()}
        />
        {/* CCUS連携ダイアログ */}
        <Confirmation
          rootClassName={styles.ccusConnectionConfirmDialog}
          visible={this.state.dialog.ccusConnectionConfirmDialog}
          title={data.dialog.ccusConnectionConfirmDialog.title}
          message={
            <CcusConnectionConfirmDialog
              approvedFlag={this.state.ccusConnectionConfirmDialog.approvedFlag}
              onChange={() => this.changeCcusApprovedFlag()}
            />
          }
          confirmButtonText={messageUtility.getMessage('I-000-054')}
          isNegative
          disabledConfirmButton={
            this.state.ccusConnectionConfirmDialog.approvedFlag === false
          }
          negativeButtonClassName={
            this.state.ccusConnectionConfirmDialog.approvedFlag === true
              ? 'btn--effective'
              : 'btn-disabled'
          }
          cancelButtonText={messageUtility.getMessage('I-000-008')}
          onConfirm={() => this.requestConnectionCcus()}
          onCancel={() => this.closeCcusConnectionConfirmDialog()}
        />
        {/* Open register worker dialog */}
        <Confirmation
          disabledConfirmButton={!havePermissionWorkerRegistrationApp}
          effectiveButtonClassName={
            havePermissionWorkerRegistrationApp
              ? 'btn'
              : 'btn-fixedsize--disabled'
          }
          rootClassName={styles.workerRegistrationApplicationDialog}
          visible={this.state.dialog.workerRegistrationApplicationDialog}
          title='代行登録依頼時の注意'
          message={<RegisterWorkerConfirmDialogMessage />}
          confirmButtonText={messageUtility.getMessage('I-000-120')}
          cancelButtonText={messageUtility.getMessage('I-000-008')}
          onConfirm={() =>
            this.events.changeMasterSlideLoader(
              'WorkerRegistrationApplication',
              {
                state: {},
              }
            )
          }
          onCancel={this.closeWorkerRegisterApplicationDialog}
        />
        <Information
          rootClassName='CcusGuideDialog'
          visible={this.state.dialog.ccusGuideDialog}
          buttonText={messageUtility.getMessage('I-000-017')}
          title={data.dialog.ccusConnectionConfirmDialog.title}
          message={
            <CcusGuideDialogBody
              isCheckedNotShowAgain={this.state.isCheckedNotShowAgainCcusGuide}
              onChangeCheckbox={this.handleChangeCcusGuideCheckbox}
            />
          }
          onClose={() => this.handleVisibleCcusGuideDialog(false)}
        />
        <Information
          message={this.state.messageContent}
          buttonText={messageUtility.getMessage('I-000-011')}
          visible={this.state.dialog.showMessageDialog === true}
          onClose={() => this.handleVisibleDialog()}
        />
        <Information
          message={
            <CcusJigyousyaDialog
              isAgencyRegister={this.state.isAgencyRegister}
            />
          }
          buttonText={messageUtility.getMessage('I-000-011')}
          visible={this.state.dialog.showDialogCcusJigyousya}
          onClose={() => this.handleVisibleDialog('showDialogCcusJigyousya')}
          rootClassName='dialog--wide'
          multilineText
        />
        <WorkersExportExcelDialog
          message={this.state.messageContent}
          downloadItems={this.state.exportFiles}
          selectedCompanyName={this.state.selectedPartnerCompanyName}
          visible={this.state.dialog.workerExportExcelDialog === true}
          onClose={this.closeWorkerExportExcelDialog}
          maxWorkerCount={this.state.maxWorkerCount}
        />
        <UpdatePartnerCompanyBranchWorkersDialog
          selectedCompanyId={this.state.selectedPartnerCompanyId}
          visible={this.state.dialog.partnerCompanyBranchDialog}
          workers={this.state.changePartnerCompanyBranchSelectedWorkers}
          onCancel={() =>
            this.toggleDialog('partnerCompanyBranchDialog', false)
          }
          onConfirm={this.handleBulkUpdatePartnerCompanyBranch}
        />
        <Information
          visible={this.state.dialog.infoDialog}
          title={this.state.infoDialogTitle}
          message={this.state.infoDialogMessage}
          buttonText={messageUtility.getMessage('I-000-017')}
          onClose={this.onCloseInfoDialog}
          multilineText={true}
        />
      </div>
    );
  }
}

/**
 * @description リスト一覧のヘッダー部分
 */
const TableHeader = ({ events, params, isPartner, isSelectAll }) => (
  <thead className='table__header'>
    <tr className='table__label'>
      <td rowSpan={2} className='value-table'>
        <div>
          {isPartner && (
            <input
              type='checkbox'
              checked={isSelectAll}
              onChange={e => {
                events.table.selectedAll(e.target.checked);
              }}
            />
          )}
        </div>
      </td>
      <td rowSpan={2} className='value-table value-table--table__label'>
        <div
          className='value-table__label'
          onClick={() => events.onSort('partner_company_branch_name')}
        >
          支店名
          {SortIcon(params, 'partner_company_branch_name')}
        </div>
      </td>
      <td rowSpan={2} className='value-table value-table--table__label'>
        <div
          className='value-table__label'
          onClick={() => events.onSort('fullname_kana')}
        >
          氏名
          {SortIcon(params, 'fullname_kana')}
        </div>
      </td>
      <td rowSpan={2} className='value-table value-table--table__label'>
        <div
          className='value-table__label'
          onClick={() => events.onSort('birthday')}
        >
          生年月日
          {SortIcon(params, 'birthday')}
        </div>
      </td>
      <td
        colSpan={4}
        className='value-table value-table--table__label disabled-sort'
      >
        <div className='value-table__label'>CCUS技能者</div>
      </td>
      <td
        rowSpan={2}
        className='value-table value-table--table__label disabled-sort'
      >
        <div className='value-table__label'>ステータス</div>
      </td>
      <td
        rowSpan={2}
        className='value-table value-table--table__label'
        style={{ minWidth: 1 }}
      >
        <div className='value-table__label' />
      </td>
      <td rowSpan={2} style={{ minWidth: '40%' }} />
    </tr>
    <tr className='table__label'>
      <td className='value-table ccus_id value-table--table__label'>
        <div
          className='value-table__label'
          onClick={() => events.onSort('ccus_engineer_id')}
        >
          ID
          {SortIcon(params, 'ccus_engineer_id')}
        </div>
      </td>
      <td className='value-table value-table--table__label disabled-sort'>
        <div className='value-table__label'>連携状態</div>
      </td>
      <td className='value-table value-table--table__label disabled-sort'>
        <div className='value-table__label'>レベル</div>
      </td>
      <td className='value-table value-table--table__label disabled-sort'>
        <div className='value-table__label'>整合性確認</div>
      </td>
    </tr>
  </thead>
);

const SortIcon = (params, key) => {
  if (params.sortkey !== key) {
    return (
      <button className='btn-icon--xs--dark btn-icon__sort btn-icon__sort--low-opacity'>
        <i className='i-sortdefault i-1x' />
      </button>
    );
  }
  if (params.order === `asc`) {
    return (
      <button className='btn-icon--xs--dark'>
        <i className='i-sortaz i-1x' />
      </button>
    );
  } else if (params.order === `desc`) {
    return (
      <button className='btn-icon--xs--dark'>
        <i className='i-sortza i-1x' />
      </button>
    );
  }
};

/**
 * @description user item コンポーネント
 */
const TableItem = ({ data, selects, events, isPartner, isRoanPermission }) => {
  const getSelected = () => {
    const _selects = _.filter(selects, item => {
      return item === data.id;
    });
    return _selects.length > 0;
  };

  // 項目の期限情報あり、協力会社管理者+労務安全権限ありのみ表示
  const hasExpiration =
    isPartner &&
    isRoanPermission &&
    _.some([data.has_about_to_expire, data.has_expired]);
  const hasForeignConstructionWorker =
    isPartner &&
    isRoanPermission &&
    _.some([data.has_foreign_construction_worker]);
  const isNotMatchingRankNameCode =
    isPartner && checkNotMatchingRankNameCode(data.rank_consistency_status);
  return (
    <tr className='table__item enable'>
      <td className='value-table construction-list-value-table__check-box'>
        <span className='label' />
        <div>
          {isPartner && (
            <input
              type='checkbox'
              checked={getSelected()}
              onClick={e => {
                e.stopPropagation();
              }}
              onChange={e => {
                events.table.selectedRow(e, data.id);
              }}
            />
          )}
        </div>
      </td>
      <td className='value-table construction-list-value-table__branch-name'>
        <span className='label'>支店名</span>
        <div className='value-table__txt--7'>
          {_.get(data, 'partner_company_branch.name', '本社')}
        </div>
      </td>
      <td className='value-table construction-list-value-table__name'>
        <span className='label'>氏名</span>
        <div className='value-table__txt--10 value-table__fullname-kana'>
          {data.fullname_kana || ''}
        </div>
        <div className='value-table__txt--7'>{data.fullname || ''}</div>
      </td>
      <td className='value-table construction-list-value-table__date'>
        <span className='label'>生年月日</span>
        <div className='value-table__date'>{data.birthday || ''}</div>
      </td>
      <td className='value-table construction-list-value-table__number'>
        <span className='label'>CCUS技能者ID</span>
        <div className='value-table__txt--10'>
          {data.ccus_engineer_id || ''}
        </div>
      </td>
      <td className='value-table construction-list-value-table__status'>
        <span className='label'>連携状態</span>
        <div
          className='value-table__txt--7'
          // style={{ minWidth: 1, whiteSpace: 'nowrap' }}
          style={{ minWidth: 1, whiteSpace: 'nowrap' }}
        >
          <CcusSyncedStatusDisplay
            syncedStatus={data.ccus_synced_status}
            isDeleted={data.ccus_jigyousya_deleted_flag}
            secededFlag={data.ccus_seceded_flag}
          />
        </div>
      </td>
      <td className='value-table construction-list-value-table__status'>
        <span className='label'>レベル</span>
        {data.rank_name_code && (
          <LevelWorkerIcon
            rankNameLevel={convertRankNameLevel(data.rank_name_code)}
          />
        )}
      </td>
      <td className='value-table construction-list-value-table__name'>
        <span className='label'>整合性確認</span>
        {data.rank_consistency_status !== null && (
          <div
            className={
              data.rank_consistency_status ===
              RANK_CONSISTENCY_STATUS.NOT_MATCHING.value
                ? 'value-table__txt--5 value-table__warning'
                : 'value-table__txt--5'
            }
          >
            {getRankConsistencyStatusName(data.rank_consistency_status)}
          </div>
        )}
      </td>
      <td className='value-table construction-list-value-table__status'>
        <div className='value-table__txt--3'>
          <StatusIcons
            blocked_on={data.blocked_on}
            events={events}
            worker={data}
            isPartner={isPartner}
          />
        </div>
      </td>
      <td className='value-table construction-list-value-table__button'>
        <span className='label'>確認</span>
        <div className='' style={{ display: 'flex' }}>
          <button
            className='btn--sm--stay'
            onClick={() => {
              events.showWorkerDetail(data.id);
            }}
          >
            確認
          </button>
          {(hasExpiration ||
            isNotMatchingRankNameCode ||
            hasForeignConstructionWorker) && (
            <ExpirationWarning
              has_expired={data.has_expired}
              isNotMatchingRankNameCode={isNotMatchingRankNameCode}
              rankConsistencyStatus={data.rank_consistency_status}
              hasExpiration={hasExpiration}
              hasForeignConstructionWorker={hasForeignConstructionWorker}
            />
          )}
        </div>
      </td>
      <td />
    </tr>
  );
};

/**
 * 作業員ステータス表示アイコン
 */
const StatusIcons = ({ blocked_on, events, worker, isPartner }) => {
  let className = '';
  let label = '';
  if (blocked_on) {
    className = 'status--short';
    label = WORKER_STATUS.RETIREMENT.NAME;
  } else {
    className = 'status--short--caution';
    label = WORKER_STATUS.ENROLLMENT.NAME;
  }
  if (isPartner) {
    className += ' status';
  }
  return (
    <div
      className={className}
      onClick={() => {
        if (isPartner) {
          events.dialog.showChangeStatus(worker);
        }
      }}
    >
      {label}
    </div>
  );
};

/**
 * CCUS連携状態表示
 */
const CcusSyncedStatusDisplay = ({ syncedStatus, isDeleted, secededFlag = false }) => {
  const status = _.find(CCUS_SYNCED_STATUS, s => {
    return s.ID === syncedStatus;
  });
  let name = '';
  // BLDE_V2-42611 CCUS事業者IDが削除されたら、ステータスは「連携解除」になるように
  if (isDeleted && syncedStatus === 3) {
    name = CCUS_SYNCED_STATUS.RELEASED.STATUS;
  } else {
    if (status !== null && status !== undefined) {
      name = status.STATUS;
      if (status.ID === CCUS_SYNCED_STATUS.DONE.ID && secededFlag) {
        name += '（期限切れ）'
      }
    }
  }

  return (
    <div
      className={
        syncedStatus === CCUS_SYNCED_STATUS.FAILED.ID
          ? 'value-table__warning value-table__txt--5'
          : 'value-table__txt--5'
      }
    >
      {name}
    </div>
  );
};

/**
 * 作業員ステータス変更ダイアログ
 */
const StatusDialog = ({ events, change_state }) => {
  return (
    <div className='status-change'>
      <div className='status-change-message'>
        ステータスを「退職」にすると、その作業員を現場に割り当てることができなくなります
      </div>
      <div className='status-change-radio'>
        <label>
          <input
            type='radio'
            name='worker_status'
            value={WORKER_STATUS.ENROLLMENT.ID}
            checked={
              WORKER_STATUS.ENROLLMENT.ID === change_state.selectWorkerStatus
            }
            onChange={() => {
              events.checkStatus(WORKER_STATUS.ENROLLMENT.ID);
            }}
          />
          <span>{WORKER_STATUS.ENROLLMENT.NAME}</span>
        </label>
        <label>
          <input
            type='radio'
            name='worker_status'
            value={WORKER_STATUS.RETIREMENT.ID}
            checked={
              WORKER_STATUS.RETIREMENT.ID === change_state.selectWorkerStatus
            }
            onChange={() => {
              events.checkStatus(WORKER_STATUS.RETIREMENT.ID);
            }}
          />
          <span>{WORKER_STATUS.RETIREMENT.NAME}</span>
        </label>
      </div>
    </div>
  );
};

/**
 * CCUS連携確認ダイアログ
 * @props {boolean} approvedFlag: 同意するボタンにチェックしたか？
 * @props {function} onChange: チェックボックスにチェックした時の処理
 * */
const CcusConnectionConfirmDialog = ({ approvedFlag, onChange }) => {
  // 画面表示
  return (
    <div>
      <p className='description'>{messageUtility.getMessage('I-002-005-05')}</p>
      <div className='approved-check-box'>
        <label>
          <input
            type='checkbox'
            checked={approvedFlag}
            onChange={event => onChange(event)}
          />
          <span>{messageUtility.getMessage('I-000-055')}</span>
        </label>
      </div>
    </div>
  );
};

const RegisterWorkerConfirmDialogMessage = () => (
  <div>
    <React.Fragment>
      <p className='description'>
        ・作業員名簿ファイルを添付いただければお客様の代わりに作業員情報の代行登録をいたします。
      </p>
      <p className='description'>
        ・様式につきましては次の申請画面をご確認ください。
      </p>
      <p className='description'>
        ・なお申請状況によっては処理完了までに時間がかかる可能性がありますので
        <br />
        {'　'}
        お急ぎの場合はご自身でBuildee画面上から登録を行っていただけますようお願いいたします。
      </p>
      <br />
      <p className='description--bold'>
        ・トライアル運用中のため、作業完了まで長くお待たせすることや、申請の受付を中止することがあります。
      </p>
    </React.Fragment>
  </div>
);

const HeaderMenu = ({
  companyId,
  events,
  isInitLoading,
  isAgencyRegister,
  openRegisterWorkerConfirmDialog,
  exportExcel,
  isRoanPermission,
  isActiveUpdatePartnerCompanyBranchButton,
}) => (
  <div className='WorkersHeaderMenu'>
    {isAgencyRegister === true && (
      <div className='btn-goback'>
        <button
          className='btn-text--sm'
          onClick={() => {
            events.goBack();
          }}
        >
          <i className='i-back--blue i-2x vertical-middle' />
          代行先一覧
        </button>
      </div>
    )}
    <div className='master-slide-view__menu'>
      {isInitLoading ? (
        <ul className='btn-menu'>
          <li className='btn-menu__item'>
            <button
              className='btn'
              onClick={() => {
                events.changeMasterSlideLoader('WorkerNew', {
                  state: { id: companyId },
                });
              }}
            >
              新規作成
            </button>
          </li>
        </ul>
      ) : (
        <ul>
          <li className='btn-menu-group'>
            <ul className='btn-menu-group__list'>
              <li className='btn-menu__item'>
                <button
                  className='btn'
                  onClick={() => {
                    events.changeMasterSlideLoader('WorkerNew', {
                      state: { id: companyId },
                    });
                  }}
                >
                  新規作成
                </button>
              </li>
              {isRoanPermission && (
                <li className='btn-menu__item'>
                  <button
                    className='btn--negative'
                    onClick={() => {
                      events.dialog.delete(true);
                    }}
                  >
                    削除
                  </button>
                </li>
              )}
            </ul>
            <HelpTextDeleteWorker className='help-text' />
          </li>

          <li>
            <ul className='btn-menu-group__list'>
              {(isActiveUpdatePartnerCompanyBranchButton ||
                (isRoanPermission && !enableTouch())) && (
                <React.Fragment>
                  <li className='btn-menu-group'>
                    <ul className='btn-menu-group__list'>
                      {isActiveUpdatePartnerCompanyBranchButton && (
                        <li className='btn-menu__item'>
                          <button
                            className='btn--sub'
                            onClick={() =>
                              events.dialog.bulkChangeCompanyBranchDialog()
                            }
                          >
                            支店の一括変更
                          </button>
                        </li>
                      )}
                      {isRoanPermission && !enableTouch() && (
                        <React.Fragment>
                          <li className='btn-menu__item'>
                            <Tippy
                              className='tooltip'
                              duration={10}
                              distance={24}
                              arrow='true'
                              arrowType='sharp'
                              delay={[100, 100]}
                              placement='bottom'
                              followCursor={true}
                              html={
                                <div className={'tippy-tooltip'}>
                                  自社作業員の情報をExcelに入力し、Buildeeにアップロードすることで
                                  <br />
                                  複数の作業員情報をまとめて新規登録・更新することができます。
                                </div>
                              }
                            >
                              <div className='tooltip-group'>
                                <button
                                  className='btn--sub'
                                  onClick={() =>
                                    events.changeMasterSlideLoader(
                                      'WorkersCapture',
                                      {
                                        state: {},
                                      }
                                    )
                                  }
                                >
                                  作業員一括取り込み
                                </button>
                                <div className='tooltip-group__icon'>
                                  <QuestionIcon className='icon--2x question-icon' />
                                </div>
                              </div>
                            </Tippy>
                          </li>
                          <li className='btn-menu__item padding-left'>
                            <Tippy
                              duration={10}
                              distance={24}
                              arrow='true'
                              arrowType='sharp'
                              delay={[100, 100]}
                              placement='bottom'
                              followCursor={true}
                              html={
                                <div className={'tippy-tooltip'}>
                                  Buildeeに登録済みの自社作業員の情報をExcel形式でダウンロードします。
                                  <br />
                                  ダウンロードしたExcelファイルは、作業員の一括取り込みに使用することができます。
                                  <br />
                                  出力する作業員を指定したい場合は、一覧で検索を行ってからボタンを押してください。
                                </div>
                              }
                            >
                              <div className='tooltip-group'>
                                <button
                                  className='btn--sub'
                                  onClick={exportExcel}
                                >
                                  作業員一覧を出力
                                </button>
                                <div className='tooltip-group__icon'>
                                  <QuestionIcon className='icon--2x question-icon' />
                                </div>
                              </div>
                            </Tippy>
                          </li>
                          <li className='btn-menu__item padding-left'>
                            <Tippy
                              duration={10}
                              distance={24}
                              arrow='true'
                              arrowType='sharp'
                              delay={[100, 100]}
                              placement='bottom'
                              followCursor={true}
                              html={
                                <div className={'tippy-tooltip'}>
                                  所定の作業員名簿データ（PDF形式）を添付していただくことにより
                                  <br />
                                  リバスタへ作業員の代行登録を依頼することができます。
                                </div>
                              }
                            >
                              <div className='tooltip-group'>
                                <button
                                  className='btn--sub'
                                  onClick={openRegisterWorkerConfirmDialog}
                                >
                                  作業員の代行登録を依頼する
                                </button>
                                <div className='tooltip-group__icon'>
                                  <QuestionIcon className='icon--2x question-icon' />
                                </div>
                              </div>
                            </Tippy>
                          </li>
                        </React.Fragment>
                      )}
                    </ul>
                  </li>
                  <li className='btn-menu-group'>
                    <div className='divider' />
                  </li>
                </React.Fragment>
              )}

              <li className='btn-menu-group'>
                <ul className='btn-menu-group__list'>
                  <li className='btn-menu__item'>
                    <Tippy
                      duration={10}
                      distance={24}
                      arrow='true'
                      arrowType='sharp'
                      delay={[100, 100]}
                      placement='bottom'
                      followCursor={true}
                      html={
                        <div className={'tippy-tooltip'}>
                          CCUS技能者IDを入力済みで未連携状態の作業員についてCCUS連携を一括で行います。
                          <br />
                          すでに連携済みの作業員の再連携は行われません。個別に連携を行ってください。
                        </div>
                      }
                    >
                      <div className='tooltip-group'>
                        <button
                          className='btn--sub'
                          onClick={events.openCcusConnectionConfirmDialog}
                        >
                          CCUS一括連携
                        </button>
                        <div className='tooltip-group__icon'>
                          <QuestionIcon className='icon--2x question-icon' />
                        </div>
                      </div>
                    </Tippy>
                  </li>
                </ul>
              </li>
            </ul>
          </li>
        </ul>
      )}
    </div>
  </div>
);

const SearchFormHeader = ({ onOpen, isOpen, total, clearParams }) => (
  <div className='search-form__header'>
    <div className='search-form__title'>
      検索条件（検索結果
      <span className='bold'>{total}</span>
      件)
    </div>
    <button
      id='accordion-toggle'
      className={isOpen ? 'accordion__btn show' : 'accordion__btn'}
      onClick={onOpen}
    />
    <button className='btn-text--sm' onClick={clearParams}>
      検索条件クリア
    </button>
  </div>
);

const SearchFormElement = ({ label, children, eleClass }) => (
  <div className='search-element'>
    <div className='search-element__label'>
      <span className='label'>{label}</span>
    </div>
    <div className={eleClass}>{children}</div>
  </div>
);

const SearchForm = ({
  onOpen,
  isOpen,
  total,
  clearParams,
  events,
  setRef,
  searchButtonRef,
  partnerCompanyJoiningFlag,
  selectedCompanyId,
  selectedPartnerCompanyBranchId,
  onSelect,
  hidePartnerCompanyBranch,
  isPartner,
  isRoanPermission,
}) => (
  <div className='master-slide-view__searchform'>
    <div className='search-form'>
      <SearchFormHeader
        onOpen={onOpen}
        isOpen={isOpen}
        total={total}
        clearParams={() => {
          clearParams();
        }}
      />
      <div
        id='search-form-accordion'
        className={isOpen ? 'accordion show' : 'accordion'}
      >
        <div className='search-form__body'>
          <div className='form form--search-form'>
            <div className='form__group flex-wrap'>
              {!hidePartnerCompanyBranch && !!partnerCompanyJoiningFlag && (
                <UserTypeSwitchForm
                  match_id={[USER_ROLES.partner.id, USER_ROLES.foreman.id]}
                >
                  <SearchFormElement
                    label='支店'
                    eleClass='search-element__item'
                  >
                    <PartnerCompanyBranchDropdown
                      selectedCompanyId={selectedCompanyId}
                      selectedPartnerCompanyBranchId={
                        selectedPartnerCompanyBranchId
                      }
                      onSelect={onSelect}
                      isOptional={true}
                      fixedOptions={[HEAD_OFFICE_OPTION]}
                      dropdownSelectStyle={{ width: '190px' }}
                    />
                  </SearchFormElement>
                </UserTypeSwitchForm>
              )}
              <SearchFormElement
                label='氏名（カナ検索可）'
                eleClass='search-element__item'
              >
                <input
                  type='text'
                  ref={ref => setRef('name_or_name_kana', ref)}
                  onInput={e => {
                    events.gets(e.target.value, 'name_or_name_kana');
                  }}
                  placeholder='作業員名を入力'
                  className=''
                />
              </SearchFormElement>
              <SearchFormElement
                label='CCUS技能者ID'
                eleClass='search-element__item--ccus'
              >
                <input
                  type='text'
                  ref={ref => setRef('ccus_engineer_id', ref)}
                  onInput={event => {
                    events.gets(event.target.value, 'ccus_engineer_id');
                  }}
                  placeholder='CCUS技能者IDを入力'
                  className=''
                />
              </SearchFormElement>
              <div className='form-element'>
                <div className='form-element__label'>
                  <span className='label'>CCUS連携状態</span>
                </div>
                <div className='element__item'>
                  <div className='AgencyCompanies__checkbox'>
                    <label className='checkbox'>
                      <input
                        name='checkbox'
                        type='checkbox'
                        disabled={false}
                        ref={ref => setRef('failed_cooperation', ref)}
                        onChange={event =>
                          events.searchCCUS(
                            event.target.checked,
                            'ccus_synced_statuses',
                            CCUS_SYNCED_STATUSES.ERROR_LINKED
                          )
                        }
                      />
                      <i className='i-square i-3x' />
                      連携エラー
                    </label>
                  </div>
                  <div className='AgencyCompanies__checkbox'>
                    <label className='checkbox'>
                      <input
                        name='checkbox'
                        type='checkbox'
                        disabled={false}
                        ref={ref => setRef('not_cooperated', ref)}
                        onChange={event =>
                          events.searchCCUS(
                            event.target.checked,
                            'ccus_synced_statuses',
                            CCUS_SYNCED_STATUSES.UN_CONFIRM
                          )
                        }
                      />
                      <i className='i-square i-3x' />
                      未設定
                    </label>
                  </div>
                  {/* BLDE_V2-50226 CCUS事業者IDは削除されたの選択条件  */}
                  <div className='AgencyCompanies__checkbox'>
                    <label className='checkbox'>
                      <input
                        name='checkbox'
                        type='checkbox'
                        disabled={false}
                        ref={ref => setRef('ccus_jigyousya_deleted_flag', ref)}
                        onChange={event =>
                          events.searchDeleted(
                            event.target.checked,
                            'ccus_jigyousya_deleted_flag',
                            'ccus_synced_statuses',
                            CCUS_JIGYOUSYA_DELETED_FLAG.RELEASED,
                            CCUS_SYNCED_STATUSES.RELEASED
                          )
                        }
                      />
                      <i className='i-square i-3x' />
                      連携解除
                    </label>
                  </div>
                </div>
              </div>
              <div className='form-element'>
                <div className='form-element__label'>
                  <span className='label'>CCUS技能レベル</span>
                </div>
                <div className='element__item'>
                  <div className='AgencyCompanies__checkbox'>
                    <label className='checkbox'>
                      <input
                        name='checkbox'
                        type='checkbox'
                        disabled={false}
                        ref={ref => setRef('not_matching', ref)}
                        onChange={event =>
                          events.searchCCUS(
                            event.target.checked,
                            'rank_consistency_statuses',
                            RANK_CONSISTENCY_STATUS.NOT_MATCHING.value
                          )
                        }
                      />
                      <i className='i-square i-3x' />
                      不整合
                    </label>
                  </div>
                  <div className='AgencyCompanies__checkbox'>
                    <label className='checkbox'>
                      <input
                        name='checkbox'
                        type='checkbox'
                        disabled={false}
                        ref={ref => setRef('un_confirm', ref)}
                        onChange={event =>
                          events.searchCCUS(
                            event.target.checked,
                            'rank_consistency_statuses',
                            RANK_CONSISTENCY_STATUS.UN_CONFIRM.value
                          )
                        }
                      />
                      <i className='i-square i-3x' />
                      未確認
                    </label>
                  </div>
                </div>
              </div>
              {isPartner && isRoanPermission && (
                <div className='form-element'>
                  <div className='form-element__label'>
                    <span className='label'>警告対象</span>
                  </div>
                  <div className='element__item'>
                    <div className='AgencyCompanies__checkbox'>
                      <label className='checkbox'>
                        <input
                          name='checkbox'
                          type='checkbox'
                          disabled={false}
                          ref={ref => setRef('has_about_to_expire', ref)}
                          onChange={event =>
                            events.gets(
                              event.target.checked,
                              'has_about_to_expire'
                            )
                          }
                        />
                        <i className='i-square i-3x' />
                        期限切れ間近情報あり
                      </label>
                    </div>
                    <div className='AgencyCompanies__checkbox'>
                      <label className='checkbox'>
                        <input
                          name='checkbox'
                          type='checkbox'
                          disabled={false}
                          ref={ref => setRef('has_expired', ref)}
                          onChange={event =>
                            events.gets(event.target.checked, 'has_expired')
                          }
                        />
                        <i className='i-square i-3x' />
                        期限切れ情報あり
                      </label>
                    </div>
                  </div>
                </div>
              )}

              <div className='form-element'>
                <div className='form-element__label'>
                  <span className='label'>ステータス</span>
                </div>
                <div className='element__item'>
                  <div className='AgencyCompanies__checkbox'>
                    <label className='checkbox'>
                      <input
                        name='checkbox'
                        type='checkbox'
                        disabled={false}
                        ref={ref => setRef('include_blocked', ref)}
                        onChange={event =>
                          events.gets(event.target.checked, 'include_blocked')
                        }
                      />
                      <i className='i-square i-3x' />
                      退職した作業員を表示
                    </label>
                  </div>
                </div>
              </div>
              <SearchFormElement>
                <button
                  className='btn--stay search-form__btn btn_top_margin'
                  onClick={events.execution}
                  ref={searchButtonRef}
                >
                  検索
                </button>
              </SearchFormElement>
            </div>
            <div className='search-form__info'>
              <div className='search-form__info-text'>
                検索条件で支店を選択して作業員が見つからない場合、支店を未選択にし氏名のみで再度検索してください。
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
);

/**
 * 作業員登録時の注意書き
 *
 * @param {number}roleId : ロールID
 * @param {boolean}isAgencyRegister : 代行登録か否か( true: 代行登録 false: 自社作業員 )
 * @param showCcusGuideDialog
 * */
const WorkerRegistrationAttention = ({
  roleId,
  isAgencyRegister,
  showCcusGuideDialog,
}) => {
  return (
    <React.Fragment>
      {/* 作業員登録ができるのは協力会社管理者のみのため、協力会社管理者の場合にのみ表示する */}
      {isPartnerRoleId(roleId) && (
        <div className='worker-registration-attention'>
          <span>
            Buildeeに登録する作業員の個人情報について、あらかじめBuildee利用規約18条第5項に記載された事項について作業員から同意を取得してください。（Buildee利用規約は&nbsp;
            <a
              href='https://service.buildee.jp/support/agreement/'
              target='_blank'
              rel='noreferrer noopener'
              className='clickable-text'
            >
              こちら
            </a>
            &nbsp;）
          </span>
          <button
            className='btn-text worker-registration-attention-link'
            onClick={showCcusGuideDialog}
          >
            CCUS連携時の確認事項
          </button>
        </div>
      )}
    </React.Fragment>
  );
};

const BackgroundLayer = ({ modalRoot, children }) => {
  const _modalRoot = document.getElementById(modalRoot);
  return ReactDOM.createPortal(children, _modalRoot);
};

// 定数
const data = {
  dialog: {
    ccusConnectionConfirmDialog: {
      title: 'CCUS連携確認',
    },
  },
};

// 期限切れアイコン ※仕様確認中
const ExpirationWarning = props => {
  const {
    has_expired,
    isNotMatchingRankNameCode,
    rankConsistencyStatus,
    hasExpiration,
    hasForeignConstructionWorker,
  } = props;

  let color = 'caution';

  let expirationText = '';
  let textNotMatchingRankNameCode = '';
  let foreignConstructionWorkerText = '';
  if (hasExpiration) {
    expirationText = messageUtility.getMessage('E-001-106');
    if (has_expired) {
      color = 'warning';
      expirationText = messageUtility.getMessage('E-001-105');
    }
  }
  if (hasForeignConstructionWorker) {
    color = 'warning';
    foreignConstructionWorkerText = messageUtility.getMessage('E-001-107');
  }
  if (isNotMatchingRankNameCode) {
    textNotMatchingRankNameCode = messageUtility.getMessage('W-000-018');

    if (rankConsistencyStatus === RANK_CONSISTENCY_STATUS.NOT_MATCHING.value) {
      color = 'warning';
      textNotMatchingRankNameCode = messageUtility.getMessage('W-000-017');
    }
  }

  const renderMessage = () => {
    const messages = [];
    if (expirationText) {
      messages.push(expirationText);
    }
    if (textNotMatchingRankNameCode) {
      messages.push(textNotMatchingRankNameCode);
    }
    if (foreignConstructionWorkerText) {
      messages.push(foreignConstructionWorkerText);
    }

    return (
      <React.Fragment>
        {messages.map((message, index) => (
          <div className='darklist__tooltip' key={index}>
            {messages.length > 1 && '・'}
            {message}
            {index < messages.length - 1 && <br />}
          </div>
        ))}
      </React.Fragment>
    );
  };

  return (
    <div
      className={`darklist__warning-icon--${color}`}
      style={{
        display: 'flex',
        alignItems: 'center',
        fontSize: 24,
        whiteSpace: 'nowrap',
        marginLeft: 8,
      }}
    >
      <Tippy
        duration={10}
        distance={24}
        arrow='true'
        arrowType='sharp'
        delay={[100, 100]}
        placement='bottom'
        followCursor={true}
        html={renderMessage()}
      >
        <i className='icon-warning_round' />
      </Tippy>
    </div>
  );
};

const HelpTextDeleteWorker = ({ className }) => (
  <div className={className}>
    退職した作業員がいる場合は
    <a
      className='clickable-text'
      href={ZENDESK_URL_GUIDE.DELETE_WORKER}
      target='_blank'
      rel='noreferrer noopener'
    >
      こちら
    </a>
    をご確認ください。
  </div>
);

const LevelWorkerIcon = ({ rankNameLevel }) => {
  return (
    <div className={`level-worker level-${rankNameLevel}`}>{rankNameLevel}</div>
  );
};

const CcusJigyousyaDialog = ({ isAgencyRegister }) => {
  const prefix = isAgencyRegister ? <span className='bold'>代行先の</span> : '';
  const href = isAgencyRegister
    ? ZENDESK_URL_GUIDE.AGENCY_CCUS_CONNECT_WARNING
    : ZENDESK_URL_GUIDE.CCUS_CONNECT_WARNING;
  return (
    <div>
      <p>CCUS連携に失敗しました。</p>
      <br />
      <p>{prefix}CCUS連携に必要な初期設定が完了していません。</p>
      <p>
        {prefix}会社情報のCCUS連携情報を入力し、再度CCUS連携を行ってください。
      </p>
      <br />
      <p>
        {prefix}CCUS連携の初期設定の詳細は
        <a
          className='clickable-text'
          href={href}
          target='_blank'
          rel='noreferrer noopener'
        >
          こちら
        </a>
        をご確認ください。
      </p>
    </div>
  );
};

const CcusGuideDialogBody = ({ isCheckedNotShowAgain, onChangeCheckbox }) => {
  return (
    <div className='CcusGuideDialogBody'>
      <span>
        作業員のCCUS連携をおこなうためには、以下のようにCCUSとBuildeeの登録が必要です。
      </span>
      <div className='CcusGuideDialogBody__image'>
        <img src={CcusGuideImage1} alt='icon-guide-1' />
        <img src={CcusGuideImage2} alt='icon-guide-2' />
      </div>
      <span>
        CCUSでの関連付けの概要と確認方法については
        <a
          href={FAQ_URL.CCUS_ASSOCIATION}
          target='_blank'
          rel='noreferrer noopener'
          className='clickable-text'
        >
          こちら
        </a>
        をご確認ください。
      </span>
      <br />
      <span>
        CCUSでの関連付けの手順については
        <a
          href={FAQ_URL.CCUS_DETAIL}
          target='_blank'
          rel='noreferrer noopener'
          className='clickable-text'
        >
          こちら
        </a>
        をご確認ください。
      </span>
      <Box mt='8px'>
        <label className='checkbox'>
          <input
            name='checkbox'
            type='checkbox'
            checked={isCheckedNotShowAgain}
            onChange={() => onChangeCheckbox(!isCheckedNotShowAgain)}
          />
          <i className='i-square i-3x' />
          今後表示しない
        </label>
      </Box>
    </div>
  );
};



// WEBPACK FOOTER //
// ./src/pages/Workers.jsx